import { CanActivateFn, Router } from '@angular/router';

export const authenticationGuard: CanActivateFn = (route, state) => {
  const router = new Router();
  var token = localStorage.getItem("jwt");
  if (state.url.includes("/authentication/")) {
    if (token) {
      router.navigate(['inventory/sales/invoice']);
      return false;
    } else {
      return true;
    }
  }
  if (token) {
    if (!state.url.includes("select-company") && !state.url.includes("in-admin") && !state.url.includes("inpartner")) {
      if (!localStorage.getItem('inin-company')){
        router.navigate(['select-company']);
        return false;
      }
    }
    return true;
  } else {
    router.navigate(['authentication/login']);
  }
  return false;
};
